import styled from "styled-components";

import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const Subtitle = styled(Text)`
    width: 70%;
`;
